import React, { useState, useEffect, useContext } from "react";
import { Col, Row, List, Button, Typography, Tag, Table } from "antd";
import {
  EditOutlined,
} from "@ant-design/icons";

import {
  DateFormat,
} from "../../../../helpers";
import Sidebar from "../../../../components/Sidebar";
import { StoreContext } from "../../../../context";
import { canWrite } from "../../../../helpers/permissions";

const { Title, Text } = Typography;

export default function CategorySectionSidebar({
  visible = false,
  data = {},
  onClose,
  editCategorySection,
}) {
  const { storeId } = useContext(StoreContext);
  const [loading, setLoading] = useState(false);

  // Define columns for the categories table
  const categoryColumns = [
    {
      title: "Sr No.",
      dataIndex: "category_id",
      key: "category_id",
      align: "center",
      width: 80,
      render: (text, record, index) => index + 1,
    },
    {
      title: "Category Name",
      dataIndex: "name",
      key: "name",
    },
  ];

  return (
    <>
      <Sidebar
        title="Category Section Details"
        visible={visible}
        loading={loading}
        onClose={onClose}
        footer={
          !storeId && canWrite() && (
            <div style={{
              display: 'flex',
              gap: '12px',
              padding: '16px 0'
            }}>
              <Button
                icon={<EditOutlined />}
                onClick={editCategorySection}
                type="primary"
                size="large"
                style={{
                  width: '100%',
                  height: '48px',
                  borderRadius: '8px'
                }}
              >
                Edit Category Section Details
              </Button>
            </div>
          )
        }
      >
        <div style={{ padding: '0 4px' }}>
          {/* Title and Status */}
          <div style={{ marginBottom: '12px' }}>
            <div style={{ display: "flex", justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px' }}>
              <Title style={{
                margin: 0,
                fontSize: '24px',
                fontWeight: 600,
                lineHeight: 1.2,
                flex: 1
              }} level={3}>
                {data.name}
              </Title>
              <span
                style={{
                  fontSize: '12px',
                  fontWeight: 500,
                  padding: "4px 12px",
                  textTransform: "uppercase",
                  borderRadius: '6px',
                  marginLeft: '12px',
                  backgroundColor: data.is_active === 1 ? '#f6ffed' : '#fff2f0',
                  color: data.is_active === 1 ? '#52c41a' : '#ff4d4f',
                  border: data.is_active === 1 ? '1px solid #b7eb8f' : '1px solid #ffccc7'
                }}
              >
                {data.is_active === 1 ? 'Active' : 'Inactive'}
              </span>
            </div>

            <Text type="secondary" style={{ fontSize: '14px' }}>
              Created: {DateFormat(data.created_at)}
            </Text>
          </div>

          {/* Description */}
          {data.description && (
            <div style={{ marginBottom: '16px' }}>
              <Text style={{ fontSize: '16px', fontWeight: 600, display: 'block', marginBottom: '12px' }}>
                Description
              </Text>
              <Text style={{ fontSize: '14px', color: '#666', lineHeight: 1.5 }}>
                {data.description}
              </Text>
            </div>
          )}

          {/* Section Details */}
          <div style={{ marginBottom: '16px' }}>
            <Text style={{ fontSize: '16px', fontWeight: 600, display: 'block', marginBottom: '12px' }}>
              Section Details
            </Text>
            <div style={{
              backgroundColor: '#f9f9f9',
              padding: '16px',
              borderRadius: '8px',
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '12px'
            }}>
              <div>
                <Text type="secondary" style={{ fontSize: '12px', display: 'block' }}>
                  Brand
                </Text>
                <Text strong style={{ fontSize: '14px' }}>
                  {data.brand_name || 'N/A'}
                </Text>
              </div>
              <div>
                <Text type="secondary" style={{ fontSize: '12px', display: 'block' }}>
                  Priority
                </Text>
                <Text strong style={{ fontSize: '14px' }}>
                  {data.priority || '-'}
                </Text>
              </div>
              <div>
                <Text type="secondary" style={{ fontSize: '12px', display: 'block' }}>
                  Total Categories
                </Text>
                <Text strong style={{ fontSize: '14px' }}>
                  {data.categories?.length || 0}
                </Text>
              </div>
              <div>
                <Text type="secondary" style={{ fontSize: '12px', display: 'block' }}>
                  Section ID
                </Text>
                <Text strong style={{ fontSize: '14px' }}>
                  {data.category_section_id || 'N/A'}
                </Text>
              </div>
            </div>
          </div>

          {/* Categories List */}
          <div style={{ marginBottom: '16px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
              <Text style={{ fontSize: '16px', fontWeight: 600 }}>
                Categories in this Section
              </Text>
            </div>

            {data.categories && data.categories.length > 0 ? (
              <Table
                columns={categoryColumns}
                dataSource={data.categories}
                rowKey="category_id"
                pagination={false}
                size="small"
                bordered
                style={{
                  backgroundColor: '#fff',
                  borderRadius: '8px',
                  overflow: 'hidden'
                }}
              />
            ) : (
              <div style={{
                padding: '24px',
                textAlign: 'center',
                backgroundColor: '#f9f9f9',
                borderRadius: '8px'
              }}>
                <Text type="secondary">No categories in this section</Text>
              </div>
            )}
          </div>
        </div>
      </Sidebar>
    </>
  );
}
